<template>
  <div :class="['grid grid--two checkout-login-register ', { 'grid--align-top': (deliveryAddress.isCompanyCustomer !== null && deliveryAddress.isCompanyCustomer || deliveryAddress.isCompanyCustomer !== null && !deliveryAddress.isCompanyCustomer) && isOpen }]">
    <div class="sign-in">
      <h3 v-epi-edit="'LoginHeader'" class="sign-in__header">
        {{ t('loginHeader') }}
      </h3>

      <p class="sign-in__description">
        {{ t('signInDescription') }}
      </p>

      <oie-sign-in-box
        register-url="registerUrl"
        :enable-merge-cart="false"
        :fetch-invoice-data="true">
      </oie-sign-in-box>
    </div>

    <div class="sign-in sign-in--register">
      <h3 class="sign-in__header">
        {{ t('checkoutRegisterHeader') }}
      </h3>

      <p class="sign-in__description">
        {{ t('checkoutRegisterDescription') }}
      </p>

      <div ref="checkoutSignUp">
        <h2 class="expandable-item__heading">
          <oie-base-button css-classes="button--with-border button--blue" :text="t('buttonGuestLabel')" @click.native="toggleAccordion()"></oie-base-button>
        </h2>
        <validation-observer
          v-if="isOpen"
          ref="checkoutSignUpForm"
          tag="form"
          class="checkout-sign-up">
          <div class="checkout-section__item">
            <validation-provider v-slot="{ errors }" rules="required">
              <fieldset
                class="input-column__container input-column__container--register"
                aria-required="true"
                :aria-invalid="errors.length ? 'true' : 'false'"
                role="radiogroup">
                <legend class="sr-only">
                  {{ tStatic('selectCustomerTypeAria') }}
                </legend>

                <oie-base-radio-checkbox
                  v-model="selectedCustomerType"
                  value="company"
                  name="customer-type"
                  area-describedby="customer-type-error"
                  :label="t('signUpCompanyLabel')"></oie-base-radio-checkbox>

                <oie-base-radio-checkbox
                  v-model="selectedCustomerType"
                  value="private"
                  name="customer-type"
                  area-describedby="customer-type-error"
                  :label="t('signUpPrivateLabel')"></oie-base-radio-checkbox>

                <div
                  v-show="errors.length"
                  :id="`customer-type-error`"
                  class="body-smaller base-radio-checkbox__error customer-type-error">
                  <oie-base-icon icon="warning" size="xs"></oie-base-icon>
                  <span v-for="error in errors" :key="error">
                    {{ error }}
                  </span>
                </div>
              </fieldset>
            </validation-provider>

            <div v-if="deliveryAddress.isCompanyCustomer !== null" class="input-column__container">
              <h3 class="input-column__header">
                {{ t('customerInformationLabel') }}
              </h3>

              <validation-provider
                v-if="useCountryDropDown && (hasMultipleMarkets || clientModel.impersonating)"
                v-slot="{errors}"
                rules="required"
                slim>
                <oie-base-dropdown
                  v-if="hasMultipleMarkets || clientModel.impersonating"
                  v-model="deliveryAddress.countryCode"
                  :label-text="`${tStatic('addressCountryLabel')}*`"
                  :default-selected="createDefaultSelection"
                  :options="clientModel.countryList"
                  :initial-text="createInitialText"
                  :use-filter-functionality="clientModel.countryList.length > 10"
                  :filter-input-placeholder="tStatic('addressCountryPlaceholder')"
                  :is-disabled="!hasMultipleMarkets"
                  container-classes="order-request__dropdown"
                  name="checkout-sign-up"
                  z-index="10"
                  :error-messages="errors"
                  @input="updateModelWithFormatingProperties">
                </oie-base-dropdown>
              </validation-provider>

              <template v-if="!useCountryDropDown && (hasMultipleMarkets || clientModel.impersonating)">
                <label class="input__label">{{ tStatic('addressCountryLabel') }}</label>
                <div class="input-column__container input-column__container--register">
                  <oie-base-radio
                    v-for="country in clientModel.countryList"
                    :id="'country' + country.value"
                    :key="'country' + country.value"
                    v-model="deliveryAddress.countryCode"
                    :is-checked="deliveryAddress && country.value === deliveryAddress.countryCode"
                    :value="country.value"
                    name="country"
                    css-classes="register-container__radio"
                    :label-text="country.text"></oie-base-radio>
                </div>
              </template>

              <div v-if="clientModel.impersonating" class="input-column__container">
                <oie-base-dropdown
                  v-model="deliveryAddress.language"
                  :label-text="tStatic('superUserUserPreferredLanguage')"
                  :options="clientModel.availibleLanguages"
                  :use-filter-functionality="false"
                  :default-selected="createDefaultLanguageSelection"
                  :is-disabled="clientModel.availibleLanguages.length <= 1"
                  name="user-language"
                  container-classes="order-request__dropdown">
                </oie-base-dropdown>
              </div>

              <validation-provider
                v-if="deliveryAddress.isCompanyCustomer"
                v-slot="{errors}"
                rules="required|invalidchars"
                slim>
                <oie-base-input
                  v-if="deliveryAddress.isCompanyCustomer"
                  id="register-company-name"
                  v-model="deliveryAddress.customerName"
                  :label-text="`${t('companyNameLabel')}*`"
                  :placeholder="t('companyNamePlaceholder')"
                  :error-messages="errors"></oie-base-input>
              </validation-provider>

              <validation-provider
                v-if="deliveryAddress.isCompanyCustomer && selectedActiveCountry && selectedActiveCountry.useVatCode"
                v-slot="{errors}"
                :debounce="500"
                :rules="createVatNumberValidateRule"
                slim>
                <oie-base-input
                  v-if="deliveryAddress.isCompanyCustomer && selectedActiveCountry && selectedActiveCountry.useVatCode"
                  id="register-company-vat"
                  v-model="formatingProperties.vatNumber"
                  :label-text="vatNumberLabel"
                  :placeholder="t('companyVATPlaceholder')"
                  error-messages="errors"
                  :prefix-value="selectedActiveCountry ? selectedActiveCountry.value : null"
                  :max-length="18"
                  @blur="updateModelWithFormatingProperties()"></oie-base-input>
              </validation-provider>

              <validation-provider
                v-if="!deliveryAddress.isCompanyCustomer"
                v-slot="{errors}"
                rules="required|invalidchars"
                slim>
                <oie-base-input
                  v-if="!deliveryAddress.isCompanyCustomer"
                  id="register-private-first-name"
                  v-model="deliveryAddress.firstName"
                  :max-length="49"
                  :label-text="`${t('privateNameLabel')}*`"
                  :placeholder="t('privateNamePlaceholder')"
                  :error-messages="errors"></oie-base-input>
              </validation-provider>

              <validation-provider
                v-if="!deliveryAddress.isCompanyCustomer"
                v-slot="{errors}"
                rules="required|invalidchars"
                slim>
                <oie-base-input
                  v-if="!deliveryAddress.isCompanyCustomer"
                  id="register-private-last-name"
                  v-model="deliveryAddress.lastName"
                  :max-length="50"
                  :label-text="`${t('privateLastNameLabel')}*`"
                  :placeholder="t('privateLastNamePlaceholder')"
                  :error-messages="errors"></oie-base-input>
              </validation-provider>

              <validation-provider
                v-slot="{errors}"
                rules="required|numeric"
                slim>
                <oie-base-input
                  id="register-company-number"
                  v-model="formatingProperties.phoneNumber"
                  :label-text="`${t('phoneNumberLabel')}*`"
                  :placeholder="t('phoneNumberPlaceholder')"
                  :max-length="27"
                  :error-messages="errors"
                  :prefix-value="selectedActiveCountry ? selectedActiveCountry.callingCode : null"
                  @blur="updateModelWithFormatingProperties()"></oie-base-input>
              </validation-provider>

              <validation-provider
                v-if="!deliveryAddress.noemail"
                v-slot="{errors}"
                rules="required|email|invalidchars"
                slim>
                <oie-base-input
                  id="register-email"
                  v-model="deliveryAddress.username"
                  :label-text="`${tStatic('email')}*`"
                  :placeholder="tStatic('emailPlaceholder')"
                  :max-length="80"
                  :error-messages="errors"></oie-base-input>
              </validation-provider>

              <oie-base-checkbox
                v-if="clientModel.impersonating"
                v-model="deliveryAddress.noemail"
                size="medium"
                is-for="checkout-no-email"
                text="Kund saknar epostadress"
                css-classes="input-column__checkbox">
              </oie-base-checkbox>
            </div>

            <div v-if="deliveryAddress.isCompanyCustomer !== null" class="input-column__container">
              <h3
                class="input-column__header">
                {{ t('addressHeaderLabel') }}
              </h3>

              <oie-address-component id="checkout-signup" :address="deliveryAddress" :use-country-dropdown="false"></oie-address-component>

              <oie-base-checkbox
                v-if="!deliveryAddress.noemail"
                v-model="deliveryAddress.newsletter"
                size="medium"
                is-for="checkout-newsletter"
                :text="t('newsletterLabel')"
                css-classes="input-column__checkbox"></oie-base-checkbox>

              <oie-base-checkbox
                v-if="!deliveryAddress.noemail"
                v-model="deliveryAddress.toggleUserPassword"
                size="medium"
                is-for="checkout-want-login"
                :text="t('createUserToggleHeader')"
                css-classes="input-column__checkbox">
              </oie-base-checkbox>
            </div>

            <section v-if="deliveryAddress.toggleUserPassword">
              <h3
                v-if="!deliveryAddress.noemail && deliveryAddress.isCompanyCustomer"
                class="input-column__header">
                {{ t('userDetailsHeader') }}
              </h3>

              <div class="input-column__container">
                <validation-provider
                  v-if="deliveryAddress.isCompanyCustomer"
                  v-slot="{errors}"
                  rules="required|invalidchars"
                  slim>
                  <oie-base-input
                    id="register-company-user-first-name"
                    v-model="deliveryAddress.firstName"
                    :max-length="49"
                    :label-text="`${t('privateNameLabel')}*`"
                    :placeholder="t('privateNamePlaceholder')"
                    :error-messages="errors"></oie-base-input>
                </validation-provider>

                <validation-provider
                  v-if="deliveryAddress.isCompanyCustomer"
                  v-slot="{errors}"
                  rules="required|invalidchars"
                  slim>
                  <oie-base-input
                    id="register-company-user-last-name"
                    v-model="deliveryAddress.lastName"
                    :max-length="50"
                    :label-text="`${t('privateLastNameLabel')}*`"
                    :placeholder="t('privateLastNamePlaceholder')"
                    :error-messages="errors"></oie-base-input>
                </validation-provider>

                <h3
                  v-if="!deliveryAddress.noemail"
                  class="input-column__header">
                  {{ t('createUserLabel') }}
                </h3>

                <template v-if="clientModel.impersonating && !deliveryAddress.noemail">
                  <oie-base-radio
                    id="password-send"
                    v-model="deliveryAddress.sendResetPassword"
                    name="sendResetPassword"
                    :value="true"
                    :is-checked="deliveryAddress.sendResetPassword"
                    size="medium"
                    is-for="checkout-send-reset-password"
                    label-text="Skicka automatiskt återställ lösenord epost"
                    css-classes="input-column__checkbox"></oie-base-radio>

                  <oie-base-radio
                    id="password-give"
                    v-model="deliveryAddress.sendResetPassword"
                    name="sendResetPassword"
                    :value="false"
                    :is-checked="!deliveryAddress.sendResetPassword"
                    size="medium"
                    is-for="checkout-give-password"
                    label-text="Ange lösenord manuellt"
                    css-classes="input-column__checkbox"></oie-base-radio>
                </template>

                <template v-if="!deliveryAddress.noemail && !deliveryAddress.sendResetPassword">
                  <validation-provider
                    v-slot="{errors}"
                    vid="pw"
                    rules="required|passwordPolicy"
                    slim>
                    <oie-base-input
                      id="register-password"
                      v-model="deliveryAddress.password"
                      type="password"
                      :label-text="`${t('createUserPasswordLabel')}*`"
                      :placeholder="t('createUserPasswordPlaceholder')"
                      :error-messages="errors"></oie-base-input>
                  </validation-provider>

                  <validation-provider
                    v-slot="{errors}"
                    rules="required|password:pw"
                    slim>
                    <oie-base-input
                      id="register-repeat-password"
                      v-model="deliveryAddress.reEnteredPassword"
                      type="password"
                      :label-text="`${t('createUserRepeatPasswordLabel')}*`"
                      :placeholder="t('createUserRepeatPasswordPlaceholder')"
                      :error-messages="errors"></oie-base-input>
                  </validation-provider>
                </template>
              </div>

              <div class="checkout-sign-up__margin-to-checkbox">
                <validation-provider v-slot="{errors}" rules="checked" slim>
                  <oie-base-checkbox
                    v-model="deliveryAddress.approveTerms"
                    size="medium"
                    is-for="checkout-approveTerms"
                    :text="t('approveTermsInformation')"
                    css-classes="input-column__checkbox"
                    :errors="errors"></oie-base-checkbox>
                  <span v-if="errors.length > 0" class="input__message--error">{{ tStatic('approveTermsMandatoryText') }}</span>
                </validation-provider>
              </div>
              <div
                v-if="clientModel.impersonating && !deliveryAddress.approveTerms"
                class="superuser-terms-reminder">
                {{ tStatic('superUserCheckoutTermsReminder') }}
              </div>
            </section>
          </div>

          <oie-base-button
            v-if="!isStepActive(componentIndex) && deliveryAddress.isCompanyCustomer !== null"
            css-classes="button--with-border button--blue input-column__button"
            :text="t('wizardNextStep')"
            :component-index="componentIndex"
            @click="validateStep"></oie-base-button>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import accordionMixin from '@/mixins/accordion.js'
import nextStepMixin from '@/mixins/checkout-next-step.js'
import { mapGetters } from 'vuex'
import countryHandling from '@/mixins/country-handling'
import _ from 'lodash'
import utils from '@/core/utils'
import { CHECKOUT_RESET_PAYMENT, CHECKOUT_RESET_SHIPPING, CHECKOUT_SIGN_UP } from '@/variables/checkout-event-keys'

export default {
  mixins: [accordionMixin, nextStepMixin, countryHandling],
  props: {
    eventKey: {
      type: String,
      default: null
    }
  },
  data: () => ({
    deliveryAddress: {
      isCompanyCustomer: false,
      username: null,
      password: null,
      customerName: null,
      firstName: null,
      lastName: null,
      phone: null,
      addressLine1: null,
      addressCo: null,
      postalCode: null,
      city: null,
      countryCode: null,
      countryName: null,
      vatNumber: '',
      newsletter: false,
      pdfInvoice: true,
      reEnteredPassword: '',
      toggleUserPassword: true,
      noemail: false,
      sendResetPassword: false,
      approveTerms: false,
      isComSite: false, // todo: remove me: this will toggle input/dropdown for country select, used for the .com site and will allow for the user to click to go to order request
      language: null
    },
    formatingProperties: {
      phoneNumber: null,
      vatNumber: null
    },
    isCompanyCustomerInitialized: false,
    isVatNumberInitialized: false,
    selectedCustomerType: null
  }),
  computed: {
    ...mapGetters('checkout', ['checkoutState', 'isOrderRequestVisitorState']),
    ...mapGetters('commerce', ['cart']),
    ...mapGetters(['enableGtm']),
    createDefaultSelection() {
      return (this.checkoutState !== undefined && this.checkoutState.deliveryAddress !== undefined) ? this.checkoutState.deliveryAddress.countryCode : null
    },
    createVatNumberValidateRule() {
      let countryCode
      if (countryHandling.selectedActiveCountry) {
        countryCode = countryHandling.selectedActiveCountry.value
      } else if (this.deliveryAddress.countryCode) {
        countryCode = this.deliveryAddress.countryCode
      }
      return countryCode ? `vatNumber:${countryCode}` : null
    },
    vatNumberLabel() {
      if (this.clientModel.currentMarket === 'se' || this.clientModel.currentMarket === 'no') {
        return this.t('companyOrgNrLabel')
      } else {
        return this.t('companyVATLabel')
      }
    },
    createDefaultLanguageSelection() {
      if (this.clientModel.availibleLanguages.find(l => l.isDefault)) {
        return this.clientModel.availibleLanguages.find(l => l.isDefault).value
      }
      return this.clientModel.availibleLanguages[0].value
    }
  },
  watch: {
    deliveryAddress: {
      deep: true,
      handler(updatedAddress) {
        this.updateAddress(updatedAddress)
      }
    },
    'selectedCustomerType'() {
      this.deliveryAddress.isCompanyCustomer = this.selectedCustomerType === 'company'
      this.publish('checkout-container-customer-type', this.deliveryAddress.isCompanyCustomer)
    },
    'deliveryAddress.countryCode'() {
      this.setActiveCountry(this.deliveryAddress.countryCode)
    },
    'deliveryAddress.isCompanyCustomer'(value) {
      if (!value) {
        this.deliveryAddress.vatNumber = ''
        this.formatingProperties.vatNumber = null
      }
      this.publish('checkout-container-customer-id-number', null)
      if (this.isCompanyCustomerInitialized) {
        this.restartStep1()
      }

      this.isCompanyCustomerInitialized = true
    },
    'deliveryAddress.vatNumber'() {
      this.publish('checkout-container-customer-id-number', null)
      if (this.isVatNumberInitialized) {
        if (this.deliveryAddress.vatNumber && this.deliveryAddress.isCompanyCustomer && this.clientModel.marketUseVatCode) { this.restartStep1() }
      }

      this.isVatNumberInitialized = true
    },
    'deliveryAddress.noemail'() {
      if (this.deliveryAddress.noemail && !this.deliveryAddress.toggleUserPassword) {
        this.deliveryAddress.toggleUserPassword = true
      }
      if (this.deliveryAddress.noemail) {
        this.deliveryAddress.username = null
      }
    },
    'deliveryAddress.toggleUserPassword'() {
      if (!this.deliveryAddress.toggleUserPassword && this.deliveryAddress.noemail) {
        this.deliveryAddress.noemail = false
      }
    }
  },
  mounted () {
    if (this.checkoutState.deliveryAddress !== undefined && (this.checkoutState.deliveryAddress.username || this.checkoutState.deliveryAddress.password || this.checkoutState.deliveryAddress.firstName || this.checkoutState.deliveryAddress.lastName || this.checkoutState.deliveryAddress.customerName)) {
      this.isOpen = true
    }

    if (this.checkoutState.deliveryAddress !== null && this.checkoutState.deliveryAddress !== undefined) {
      this.deliveryAddress = this.checkoutState.deliveryAddress

      if (this.deliveryAddress.countryCode) {
        this.formatingProperties.phoneNumber = utils.extractPhoneNumberFromFormating(this.deliveryAddress.phone, this.getCallingCode())
        this.formatingProperties.vatNumber = utils.extractVatNumberFromFormating(this.deliveryAddress.vatNumber, this.deliveryAddress.countryCode)
      }

      if (this.deliveryAddress.isCompanyCustomer !== null && this.deliveryAddress.isCompanyCustomer !== undefined) {
        this.selectedCustomerType = this.deliveryAddress.isCompanyCustomer ? 'company' : 'private'
      }
    }
  },
  methods: {
    validateStep() {
      this.$refs.checkoutSignUpForm.validate().then((valid) => {
        if (valid) {
          if (this.deliveryAddress.toggleUserPassword && this.deliveryAddress.approveTerms) {

          }
          this.publish(`checkout-wizard-step-${this.componentIndex}`, this.componentIndex)
        }
      })
    },
    updateAddress: _.debounce(function(updatedAddress) {
      this.publish(CHECKOUT_SIGN_UP, updatedAddress)
    }, 500),
    updateModelWithFormatingProperties() {
      if (this.formatingProperties.phoneNumber && this.deliveryAddress.countryCode !== null) {
        const currentCountry = this.countryList.find(c => c.value === this.deliveryAddress.countryCode)

        if (currentCountry) {
          this.deliveryAddress.phone = utils.savePhoneNumberWithFormating(this.formatingProperties.phoneNumber, currentCountry.callingCode)
          this.formatingProperties.phoneNumber = utils.extractPhoneNumberFromFormating(this.formatingProperties.phoneNumber, currentCountry.callingCode)
        }
      } else if (this.formatingProperties.phoneNumber && this.formatingProperties.phoneNumber !== null && this.formatingProperties.phoneNumber.length === 0 && this.deliveryAddress.phone) {
        this.deliveryAddress.phone = null
      }

      if (this.formatingProperties.vatNumber && this.deliveryAddress.countryCode !== null) {
        this.deliveryAddress.vatNumber = utils.saveVatNumberWithFormating(this.formatingProperties.vatNumber, this.deliveryAddress.countryCode)
        if (this.customer) {
          this.customer.idNumber = this.deliveryAddress.vatNumber
        }
      } else {
        this.deliveryAddress.vatNumber = null
      }
    },
    getCallingCode() {
      return this.countryList.find(c => c.value === this.deliveryAddress.countryCode).callingCode
    },
    restartStep1() {
      const isStepTwoActive = this.isStepActive(1)
      const isStepThreeActive = this.isStepActive(2)

      if (isStepTwoActive || isStepThreeActive) {
        if (isStepTwoActive) {
          this.publish(CHECKOUT_RESET_PAYMENT)
        }

        if (isStepThreeActive) {
          this.publish(CHECKOUT_RESET_SHIPPING)
        }

        if (isStepTwoActive || isStepThreeActive) {
          this.removeOnlyActiveSteps([2, 3, 4])
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .checkout-login-register .sign-in {
  @include brand-border;
  padding: measure(full);
  background-color: color(background-white);
  border: 1px solid color(border-gray);
  border-bottom: 0;
  }

  .checkout-sign-up__customer-type {
  display: flex;
  }

  .checkout-sign-up__customer-type > *:first-child {
  margin-right: measure(full);
  }

  .checkout-sign-up .input-column__container {
  max-width: 24rem;
  }

  .checkout-sign-up .checkout-sign-up__margin-to-checkbox {
  margin-top: measure(full);
  }

  .checkout-sign-up .superuser-terms-reminder {
  background-color: #ffa;
  border: #999 1px solid;
  text-align: center;
  padding: measure(quarter);
  }
</style>
